export const month = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];
export const days = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];
export const datePickerShortDays = [
  "sunday-short",
  "monday-short",
  "tuesday-short",
  "wednesday-short",
  "thursday-short",
  "friday-short",
  "saturday-short",
];
export const currentMonth = new Date().getMonth();
export const currentYear = new Date().getFullYear();

//return YYYY-MM-DD
export function convertDate(date) {
  var yyyy = date.getFullYear().toString();
  var mm = (date.getMonth() + 1).toString();
  var dd = date.getDate().toString();
  var mmChars = mm.split("");
  var ddChars = dd.split("");
  return (
    yyyy +
    "-" +
    (mmChars[1] ? mm : "0" + mmChars[0]) +
    "-" +
    (ddChars[1] ? dd : "0" + ddChars[0])
  );
}

//DD/MM/YYYY
export function convertDateNewForamt(date) {
  var yyyy = date.getFullYear().toString();
  var mm = (date.getMonth() + 1).toString();
  var dd = date.getDate().toString();
  var mmChars = mm.split("");
  var ddChars = dd.split("");
  return (
    yyyy +
    "/" +
    (mmChars[1] ? mm : "0" + mmChars[0]) +
    "/" +
    (ddChars[1] ? dd : "0" + ddChars[0])
  );
}

export function convertDate2(date) {
  var yyyy = date.getFullYear().toString();
  var mm = (date.getMonth() + 1).toString();
  var dd = date.getDate().toString();
  var mmChars = mm.split("");
  var ddChars = dd.split("");
  return (
    (ddChars[1] ? dd : "0" + ddChars[0]) +
    "-" +
    (mmChars[1] ? mm : "0" + mmChars[0]) +
    "-" +
    yyyy
  );
}

//get number of days in month
export function getNumberOfDaysInMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
}

//get day (1-7) of date
export function getWeekday(date) {
  var d = new Date(date);
  var n = d.getDay();
  return n;
}

//get last sunday of month
export function lastSunday(year, month) {
  var date = new Date(year, month, 1, 12);
  let weekday = date.getDay();
  let dayDiff = weekday === 0 ? 7 : weekday;
  let lastSunday = date.setDate(date.getDate() - dayDiff);
  return date.toDateString();
}

//create the days in prev month for calendar
export function createDaysForPreviousMonth(year, month) {
  const firstDayOfTheMonthWeekday =
    getWeekday(convertDate(new Date(year, month + 1, 1))) + 1;
  let previousMonthNum = 0;
  let previousMonth = null;
  if (month > 1) {
    previousMonthNum = month;
    previousMonth = new Date(year, previousMonthNum, 1);
  } else {
    previousMonthNum = 12;
    previousMonth = new Date(year - 1, previousMonthNum, 1);
  }
  // Cover first day of the month being sunday (firstDayOfTheMonthWeekday === 0)
  const visibleNumberOfDaysFromPreviousMonth = firstDayOfTheMonthWeekday
    ? firstDayOfTheMonthWeekday - 1
    : 6;

  const previousMonthLastSundayDayOfMonth = new Date(
    lastSunday(year, month + 1)
  ).getDate();

  return [...Array(visibleNumberOfDaysFromPreviousMonth)].map((day, index) => {
    return {
      date: convertDate(
        new Date(
          `${previousMonth.getFullYear()}-${previousMonth.getMonth() + 1}-${
            previousMonthLastSundayDayOfMonth + index
          }`
        )
      ),
      dayOfMonth: previousMonthLastSundayDayOfMonth + index,
      isCurrentMonth: false,
    };
  });
}

//create the days in current month for calendar
export function createDaysForCurrentMonth(year, month) {
  return [...Array(getNumberOfDaysInMonth(year, month))].map((day, index) => {
    return {
      date: convertDate(new Date(year, month, index + 1)),
      dayOfMonth: index + 1,
      isCurrentMonth: true,
    };
  });
}

//create the days in next month for calendar
export function createDaysForNextMonth(year, month) {
  const lastDayOfTheMonthWeekday = getWeekday(lastSunday(year, month)) + 1;
  const visibleNumberOfDaysFromNextMonth = lastDayOfTheMonthWeekday
    ? 7 - lastDayOfTheMonthWeekday
    : lastDayOfTheMonthWeekday;
  return [...Array(visibleNumberOfDaysFromNextMonth)].map((day, index) => {
    return {
      date: convertDate(new Date(year, month, index + 1)),
      dayOfMonth: index + 1,
      isCurrentMonth: false,
    };
  });
}
